import React, { ReactNode, FC } from 'react'
import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const FadeInWrapper = styled.div<{ fadeTime: number }>`
	height: 100%;
	animation: ${fadeIn} ${(props) => props.fadeTime}ms linear;
`

type FadeWrapperProps = {
	children: ReactNode
	fadeTime?: number
}

const FadeWrapper: FC<FadeWrapperProps> = ({ children, fadeTime = 400 }) => {
	return <FadeInWrapper fadeTime={fadeTime}>{children}</FadeInWrapper>
}

export default FadeWrapper
